import type { RxJsonSchema } from 'rxdb';
import type { PlannedDeficiencyList } from './existingDeficiencyList.types';

export const plannedDeficiencyListSchema: RxJsonSchema<PlannedDeficiencyList> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'pkDeficiencyUUID',
  properties: {
    assetPCSId: { type: 'string' },
    assetId: { type: ['number', 'null'] },
    pkDeficiencyUUID: { type: 'string', maxLength: 36 },
    componentFailureId: { type: 'string' },
    pcsId: { type: ['string', 'null'] },
    repairFactorId: { type: ['number', 'null'] },
    isCompletedDuringInspection: { type: ['boolean', 'null'] },
    componentType: { type: ['string', 'null'] },
    remedialAction: { type: ['string', 'null'] },
    causeOfFailure: { type: ['string', 'null'] },
    remedialActionId: { type: ['number', 'null'] },
    commentRemedialAction: { type: ['string', 'null'] },
    assetCategoryComponentId: { type: ['number', 'null'] },
    commentAssetComponent: { type: ['string', 'null'] },
    assetInspectionId: { type: ['number', 'null'] },
    failureCauseCategory: { type: ['number', 'null'] },
    areaId: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    locationDescription: { type: ['string', 'null'] },
    commentObservation: { type: ['string', 'null'] },
    name: { type: ['string', 'null'] },
    dateObserved: { type: ['string', 'null'] },
    site: { type: 'number' },
    discipline: { type: 'number' },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    isDelete: { type: ['string', 'null'] },
    fieldInspectorId: { type: ['number', 'null'] },
    leadInspectorId: { type: ['number', 'null'] },
    inspectionTaskId: { type: ['number', 'null'] },
    commentSiteCoordinator: { type: ['string', 'null'] },
    commentInspectorLead: { type: ['string', 'null'] },
    commentInspectorField: { type: ['string', 'null'] },
    attentionFlag: { type: ['boolean', 'null'] },
    taskStatusCategory: { type: ['number', 'null'] },
    componentAreaInfo: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          componentFailureId: { type: ['number', 'null'] },
          areaId: { type: ['number', 'null'] },
          areaPcsId: { type: ['string', 'null'] },
          inspectionId: { type: ['number', 'null'] },
          trafficSafety: { type: ['number', 'null'] },
        },
      },
    },
  },
};
